import { useRef, useState } from "react";
import type { DragEvent } from "react";

interface Props {
  onFile: (file: File) => void;
  error: string | null;
  busy: boolean;
}

export default function FileDrop({ onFile, error, busy }: Props) {
  const inputRef = useRef<HTMLInputElement>(null);
  const [dragOver, setDragOver] = useState(false);

  const handleDrop = (e: DragEvent) => {
    e.preventDefault();
    setDragOver(false);
    const file = e.dataTransfer.files?.[0];
    if (file) onFile(file);
  };

  return (
    <div
      className={`dropzone${dragOver ? " over" : ""}${busy ? " busy" : ""}`}
      onDragOver={(e) => {
        e.preventDefault();
        setDragOver(true);
      }}
      onDragLeave={() => setDragOver(false)}
      onDrop={handleDrop}
      onClick={() => inputRef.current?.click()}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") inputRef.current?.click();
      }}
    >
      <input
        ref={inputRef}
        type="file"
        accept=".fit"
        hidden
        onChange={(e) => {
          const file = e.target.files?.[0];
          if (file) onFile(file);
          e.target.value = "";
        }}
      />
      <div className="drop-icon" aria-hidden>
        ⤓
      </div>
      <p className="drop-title">
        {busy ? "Reading…" : "Drop a .fit file here"}
      </p>
      <p className="drop-sub">or click to choose a file</p>
      <p className="drop-note">
        Everything runs in your browser — your ride never leaves your device.
      </p>
      {error && <p className="drop-error">{error}</p>}
    </div>
  );
}
